import axiosInstance from '@/utils/api.js'

var state = {
  ipTrafficService: []
}

var getters = {
  IP_TRAFFIC_SERVICE: (state) => {
    return state.ipTrafficService
  }
}

var mutations = {
  SET_IP_TRAFFIC_SERVICE: (state, payload) => {
    state.ipTrafficService = payload
  }
}

var actions = {
  GET_IP_TRAFFIC_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/iptraffic?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_IP_TRAFFIC_SERVICE', result.data)
    }
  },
  CREATE_IP_TRAFFIC_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/iptraffic', payload)
  },
  UPDATE_IP_TRAFFIC_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/iptraffic', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/ipTrafficServices.js